import {ChangeDetectionStrategy, Component, forwardRef, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {ProductCheckedInfo} from '../../../dto/product';
import {OrderService} from '../../services/order.service';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {MatRadioChange} from '@angular/material/radio';

export const CARD_SELECT_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CardSelectorComponent),
  multi: true,
};


@Component({
  moduleId: module.id,
  selector: 'app-card-selector',
  templateUrl: './card-selector.component.html',
  styleUrls: ['./card-selector.component.css'],
  providers: [CARD_SELECT_VALUE_ACCESSOR],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Default,
})
export class CardSelectorComponent implements ControlValueAccessor, OnInit {
  @Input() companyId: number;
  _products: ProductCheckedInfo[];

  set products(val) {
    this._products = val;
    if ( this._products) {
      this._products.forEach((p) => {
        if ( p.checked === true ) {
          this.writeValue(p.id);
          this.onChange(p.id);
        }
      });
    }

  }

  @Input()
  get products() {
    return this._products;
  }

  onChange;
  onTouched;
  productId: number;


  constructor(private orderService: OrderService) { }

  ngOnInit(): void {

  }

  change(event: MatRadioChange) {
    this.onChange(event.source.checked ? event.source.value : null);
  }

  writeValue(value: any): void {
    this.productId = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

}
